var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const initProductCard = /* @__PURE__ */ __name(($el, $refs, productHandle, productId, variantId, default_select_selling_plan = false) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A, _B, _C, _D, _E, _F, _G, _H;
  const random_id = utils.shortUUID();
  const addon_target = (_a = $el.closest(".shopify-section")) == null ? void 0 : _a.querySelector(`form[data-handle="${$el.getAttribute("data-addon-product-target")}"]`);
  const addon_auto_add = $el.hasAttribute("data-addon-auto-add");
  const addon_bundle_in_cart = $el.hasAttribute("data-addon-cart-bundle");
  const preorder_threshold = +((_b = window.theme_settings.data__product__variant__preorder_threshold) != null ? _b : 1);
  const cart = window.Alpine.store("cart");
  const settings = utils.JSONParse($el.getAttribute("data-settings"));
  const option_blocks = [
    ...((_c = $el.querySelectorAll("[data-options-block]")) == null ? void 0 : _c.length) ? $el.querySelectorAll("[data-options-block]") : (_f = (_e = (_d = $el.querySelector("template")) == null ? void 0 : _d.content) == null ? void 0 : _e.querySelectorAll("[data-options-block]")) != null ? _f : []
  ].map(
    (block) => utils.JSONParse(block.getAttribute("data-options-block"))
  );
  let product = (_g = _products[productHandle]) != null ? _g : _product.getHtmlProduct(productHandle);
  if (!product) {
    _product.getProductData(productHandle, productId).then((res) => {
      updateProductState(res);
    });
  }
  product != null ? product : product = _products[productHandle];
  if (settings == null ? void 0 : settings.default_variant_metafield) {
    const [namespace, key] = settings.default_variant_metafield.trim().split(".");
    const variant = (_i = (_h = product == null ? void 0 : product.metafields) == null ? void 0 : _h[namespace]) == null ? void 0 : _i[key];
    variantId = (_j = variant == null ? void 0 : variant.id) != null ? _j : product == null ? void 0 : product.selected_variant_id;
  }
  const selected_variant = _product.getSelectedVariant(product, variantId);
  const selling_plan_allocations = selected_variant == null ? void 0 : selected_variant.selling_plan_allocations;
  const selected_selling_plan = default_select_selling_plan || (product == null ? void 0 : product.requires_selling_plan) ? (_k = selling_plan_allocations == null ? void 0 : selling_plan_allocations[0]) == null ? void 0 : _k.selling_plan : null;
  const selling_plan_discount_wording = +((_m = (_l = selected_selling_plan == null ? void 0 : selected_selling_plan.price_adjustments) == null ? void 0 : _l[0]) == null ? void 0 : _m.value) ? ((_o = (_n = selected_selling_plan == null ? void 0 : selected_selling_plan.price_adjustments) == null ? void 0 : _n[0]) == null ? void 0 : _o.value_type) === "fixed_amount" ? `${utils.formatMoney((_q = (_p = selected_selling_plan == null ? void 0 : selected_selling_plan.price_adjustments) == null ? void 0 : _p[0]) == null ? void 0 : _q.value)}` : ((_s = (_r = selected_selling_plan == null ? void 0 : selected_selling_plan.price_adjustments) == null ? void 0 : _r[0]) == null ? void 0 : _s.value_type) === "percentage" ? `${(_u = (_t = selected_selling_plan == null ? void 0 : selected_selling_plan.price_adjustments) == null ? void 0 : _t[0]) == null ? void 0 : _u.value}%` : "" : "";
  const available_quantity = (selected_variant == null ? void 0 : selected_variant.inventory_management) === "shopify" && (selected_variant == null ? void 0 : selected_variant.inventory_policy) === "deny" ? (selected_variant == null ? void 0 : selected_variant.inventory_quantity) - ((_w = (_v = cart == null ? void 0 : cart.state) == null ? void 0 : _v.items) == null ? void 0 : _w.reduce((acc, line) => line.variant_id === selected_variant.id ? acc + line.quantity : acc, 0)) : (selected_variant == null ? void 0 : selected_variant.preorder) && (selected_variant == null ? void 0 : selected_variant.preorder_quantity) ? (selected_variant == null ? void 0 : selected_variant.inventory_quantity) + (selected_variant == null ? void 0 : selected_variant.preorder_quantity) - ((_y = (_x = cart == null ? void 0 : cart.state) == null ? void 0 : _x.items) == null ? void 0 : _y.reduce((acc, line) => line.variant_id === selected_variant.id ? acc + line.quantity : acc, 0)) : 99999;
  const state = window.Alpine.reactive({
    product_handle: productHandle,
    random_id,
    addon_target,
    addon_auto_add,
    addon_bundle_in_cart,
    hydrated: !!product,
    variant_changed: false,
    settings,
    product,
    selected_media_id: (_A = (_z = product == null ? void 0 : product.media) == null ? void 0 : _z[0]) == null ? void 0 : _A.id,
    properties: {},
    selected_variant,
    selling_plan_allocations,
    selected_selling_plan,
    selling_plan_discount_wording,
    isAdding: false,
    selected_options: selected_variant == null ? void 0 : selected_variant.options,
    quantity: 1,
    sibling_handle: "",
    hasVariants: ((_B = product == null ? void 0 : product.variants) == null ? void 0 : _B.length) > 1 || ((_D = (_C = product == null ? void 0 : product.variants) == null ? void 0 : _C[0]) == null ? void 0 : _D.title) !== "Default Title",
    hasSubscription: !!((_E = selected_variant == null ? void 0 : selected_variant.options) == null ? void 0 : _E.length),
    soldOut: available_quantity <= 0,
    available_quantity,
    preorder: (selected_variant == null ? void 0 : selected_variant.preorder) && (selected_variant == null ? void 0 : selected_variant.inventory_quantity) - ((_G = (_F = cart == null ? void 0 : cart.state) == null ? void 0 : _F.items) == null ? void 0 : _G.reduce((acc, line) => line.variant_id === selected_variant.id ? acc + line.quantity : acc, 0)) < preorder_threshold,
    gallery_media: (_H = product == null ? void 0 : product.media) != null ? _H : []
  });
  const handleImageSelection = /* @__PURE__ */ __name((filter_images, variant = state.selected_variant) => {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2, _j2, _k2, _l2, _m2, _n2, _o2, _p2, _q2, _r2, _s2, _t2, _u2, _v2;
    switch (filter_images) {
      case "show_all": {
        state.gallery_media = (_a2 = state.product) == null ? void 0 : _a2.media;
        break;
      }
      case "selected_variant": {
        state.gallery_media = (_c2 = (_b2 = state.product) == null ? void 0 : _b2.media) == null ? void 0 : _c2.filter((media) => {
          var _a3;
          return media.id === ((_a3 = variant == null ? void 0 : variant.featured_media) == null ? void 0 : _a3.id);
        });
        break;
      }
      case "variant_images_by_order": {
        let hide = true;
        state.gallery_media = (_e2 = (_d2 = state.product) == null ? void 0 : _d2.media) == null ? void 0 : _e2.filter((media) => {
          var _a3, _b3;
          if (media.id === ((_a3 = variant == null ? void 0 : variant.featured_media) == null ? void 0 : _a3.id)) {
            hide = false;
          }
          if ((_b3 = state.product) == null ? void 0 : _b3.variants.map((v) => {
            var _a4;
            return (_a4 = v == null ? void 0 : v.featured_media) == null ? void 0 : _a4.id;
          }).includes(media.id)) {
            hide = true;
          }
          return !hide;
        });
        break;
      }
      case "variant_images_by_metafield": {
        state.gallery_media = [
          ...(_h2 = (_g2 = (_f2 = state.product) == null ? void 0 : _f2.media) == null ? void 0 : _g2.filter((media) => {
            var _a3;
            return media.id === ((_a3 = variant == null ? void 0 : variant.featured_media) == null ? void 0 : _a3.id);
          })) != null ? _h2 : [],
          ...(_l2 = (_k2 = (_j2 = (_i2 = state.selected_variant) == null ? void 0 : _i2.metafields) == null ? void 0 : _j2.smart) == null ? void 0 : _k2.images) != null ? _l2 : []
        ];
        break;
      }
      case "variant_images_and_unassigned": {
        state.gallery_media = [
          ...(_o2 = (_n2 = (_m2 = state.product) == null ? void 0 : _m2.media) == null ? void 0 : _n2.filter((media) => {
            var _a3;
            return media.id === ((_a3 = variant == null ? void 0 : variant.featured_media) == null ? void 0 : _a3.id);
          })) != null ? _o2 : [],
          ...(_r2 = (_q2 = (_p2 = state.product) == null ? void 0 : _p2.media) == null ? void 0 : _q2.filter(
            (media) => {
              var _a3;
              return !((_a3 = state.product) == null ? void 0 : _a3.variants.map((v) => {
                var _a4;
                return (_a4 = v == null ? void 0 : v.featured_media) == null ? void 0 : _a4.id;
              }).includes(media.id));
            }
          )) != null ? _r2 : []
        ];
        break;
      }
      case "only_unassigned": {
        state.gallery_media = (_t2 = (_s2 = state.product) == null ? void 0 : _s2.media) == null ? void 0 : _t2.filter(
          (media) => {
            var _a3;
            return !((_a3 = state.product) == null ? void 0 : _a3.variants.map((v) => {
              var _a4;
              return (_a4 = v == null ? void 0 : v.featured_media) == null ? void 0 : _a4.id;
            }).includes(media.id));
          }
        );
        break;
      }
      case "first_or_selected_image": {
        state.gallery_media = (_v2 = (_u2 = state.product) == null ? void 0 : _u2.media) == null ? void 0 : _v2.filter((media) => media.id === state.selected_media_id);
        break;
      }
    }
  }, "handleImageSelection");
  const scrollToMediaById = /* @__PURE__ */ __name(async (mediaId, scrollContainer) => {
    var _a2, _b2;
    const isHorizontal = /* @__PURE__ */ __name(() => {
      return !!(getComputedStyle(scrollContainer).overflowY === "hidden" || getComputedStyle(scrollContainer).gridAutoFlow === "column" || scrollContainer.scrollWidth > (scrollContainer == null ? void 0 : scrollContainer.clientWidth));
    }, "isHorizontal");
    await utils.delay(5);
    const image = scrollContainer == null ? void 0 : scrollContainer.querySelector(`[data-media-id="${mediaId}"]`);
    if (!image) return;
    await utils.delay(5);
    const header = document.querySelector(".header-sections-container");
    const offsetHeight = Math.max(180, (_b2 = (_a2 = header == null ? void 0 : header.getBoundingClientRect()) == null ? void 0 : _a2.bottom) != null ? _b2 : 0);
    const imageOffset = utils.getElementPosition(image);
    if (utils.isElementScrollable(scrollContainer)) {
      let scrollSnap = false;
      if (["snap-both", "snap-x", "snap-y"].some((c) => {
        var _a3;
        return (_a3 = scrollContainer == null ? void 0 : scrollContainer.classList) == null ? void 0 : _a3.contains(c);
      })) {
        scrollContainer == null ? void 0 : scrollContainer.classList.remove("snap-both", "snap-x", "snap-y");
        scrollSnap = true;
      }
      utils.scrollToXY(200, image.offsetLeft, image.offsetTop, scrollContainer, () => {
        if (scrollSnap) {
          scrollContainer == null ? void 0 : scrollContainer.classList.add(isHorizontal() ? "snap-x" : "snap-y");
        }
        state.selected_media_id = mediaId;
      });
      return;
    }
    if (scrollContainer.closest("[data-modal-id]")) return;
    utils.scrollToXY(
      200,
      image.offsetLeft,
      imageOffset.top - offsetHeight - +getComputedStyle(scrollContainer).paddingTop.replace("px", ""),
      window,
      () => {
        state.selected_media_id = mediaId;
      }
    );
  }, "scrollToMediaById");
  const handleAddToCart = /* @__PURE__ */ __name(async (e, openCartDrawer = true) => {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2, _j2, _k2;
    const properties = {};
    const form = $el.querySelector("form");
    const isGiftItem = (_a2 = $el.closest("[data-gift-with-purchase]")) == null ? void 0 : _a2.getAttribute("data-gift-with-purchase");
    if (isGiftItem) {
      properties["_gift_with_purchase"] = "true";
    }
    const property = (_b2 = form.querySelector("[data-property]")) == null ? void 0 : _b2.getAttribute("data-property");
    if (property !== "") {
      properties[property] = "true";
    }
    if (((_c2 = state.selected_variant) == null ? void 0 : _c2.preorder) && ((_d2 = state.selected_variant) == null ? void 0 : _d2.inventory_quantity) < preorder_threshold) {
      properties["Preorder"] = `true`;
      if ((_e2 = state.selected_variant) == null ? void 0 : _e2.preorder_date) {
        properties["Preorder"] = `Shipping ${new Date(state.selected_variant.preorder_date).toLocaleDateString(
          navigator.language,
          {
            month: "short",
            year: "numeric"
          }
        )}`;
      }
    }
    if (form) {
      (_f2 = Object.entries(utils.serializeForm($el.querySelector("form")))) == null ? void 0 : _f2.forEach(([key, value]) => {
        if (key.includes("properties[") && value) {
          properties[key.replace(/^properties\[(.*)]$/gi, "$1")] = value;
        }
      });
    }
    e == null ? void 0 : e.preventDefault();
    e == null ? void 0 : e.stopPropagation();
    state.isAdding = true;
    const data = await _cart.add({
      items: [
        {
          id: state.selected_variant.id,
          quantity: state.quantity,
          selling_plan: cart.global_subscriptions ? (_j2 = (_i2 = (_h2 = (_g2 = state.selected_variant) == null ? void 0 : _g2.selling_plan_allocations) == null ? void 0 : _h2.find(
            (plan) => {
              var _a3;
              return ((_a3 = plan.selling_plan) == null ? void 0 : _a3.id) === cart.cart_selling_plan_id;
            }
          )) == null ? void 0 : _i2.selling_plan) == null ? void 0 : _j2.id : (_k2 = state.selected_selling_plan) == null ? void 0 : _k2.id,
          properties: {
            ...properties,
            ...state.properties
          }
        }
      ]
    });
    state.isAdding = false;
    if (openCartDrawer) {
      _stores.modal.setId("modal--cart-drawer");
      _stores.quickView.show = false;
    }
  }, "handleAddToCart");
  const handleBackInStockNotification = /* @__PURE__ */ __name(async (e) => {
    var _a2;
    if ((_a2 = state == null ? void 0 : state.selected_variant) == null ? void 0 : _a2.available) return;
    e.preventDefault();
    e.stopPropagation();
    _stores.modal.setId("back_in_stock");
    _stores.backInStockNotification.product = state.product;
    _stores.backInStockNotification.selected_variant = state.selected_variant;
  }, "handleBackInStockNotification");
  const setSelectedVariant = /* @__PURE__ */ __name((id) => {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2, _j2, _k2, _l2, _m2, _n2, _o2, _p2, _q2;
    state.selected_variant = (_a2 = state.product.variants) == null ? void 0 : _a2.find((variant) => variant.id === id);
    state.selected_options = state.selected_variant.options;
    state.variant_changed = true;
    if (state.selected_selling_plan && !((_c2 = (_b2 = state.selected_variant) == null ? void 0 : _b2.selling_plan_allocations) == null ? void 0 : _c2.some(
      (plan) => {
        var _a3, _b3;
        return ((_a3 = plan == null ? void 0 : plan.selling_plan) == null ? void 0 : _a3.id) === ((_b3 = state.selected_selling_plan) == null ? void 0 : _b3.id);
      }
    ))) {
      state.selected_selling_plan = (_g2 = (_f2 = (_e2 = (_d2 = state.selected_variant) == null ? void 0 : _d2.selling_plan_allocations) == null ? void 0 : _e2[0]) == null ? void 0 : _f2.selling_plan) != null ? _g2 : null;
    }
    if (state.product.requires_selling_plan && !state.selected_selling_plan) {
      state.selected_selling_plan = (_n2 = (_j2 = (_i2 = (_h2 = state.selected_variant) == null ? void 0 : _h2.selling_plan_allocations) == null ? void 0 : _i2[0]) == null ? void 0 : _j2.selling_plan) != null ? _n2 : (_m2 = (_l2 = (_k2 = state.product.selling_plan_groups) == null ? void 0 : _k2[0]) == null ? void 0 : _l2.selling_plans) == null ? void 0 : _m2[0];
    }
    _product.lastOptions = {
      ...(_o2 = _product.lastOptions) != null ? _o2 : {},
      ...(_q2 = (_p2 = state.product.options_with_values) == null ? void 0 : _p2.reduce((acc, option, index) => {
        var _a3;
        acc[(_a3 = option == null ? void 0 : option.name) == null ? void 0 : _a3.toLowerCase()] = state.selected_options[index];
        return acc;
      }, {})) != null ? _q2 : {}
    };
  }, "setSelectedVariant");
  const setProductOption = /* @__PURE__ */ __name(({ index, value }) => {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2, _j2, _k2, _l2, _m2, _n2;
    const options = [...state.selected_options];
    options[index] = value;
    setSelectedVariant(
      (_n2 = (_j2 = (_f2 = (_b2 = (_a2 = state.product.variants) == null ? void 0 : _a2.find((variant) => variant.options.every((option, i) => options[i] === option))) == null ? void 0 : _b2.id) != null ? _f2 : (_e2 = (_d2 = (_c2 = state.product) == null ? void 0 : _c2.variants) == null ? void 0 : _d2.find((variant) => variant.options[index] === value)) == null ? void 0 : _e2.id) != null ? _j2 : (_i2 = (_h2 = (_g2 = state.product) == null ? void 0 : _g2.variants) == null ? void 0 : _h2.find(({ available }) => available)) == null ? void 0 : _i2.id) != null ? _n2 : (_m2 = (_l2 = (_k2 = state.product) == null ? void 0 : _k2.variants) == null ? void 0 : _l2[0]) == null ? void 0 : _m2.id
    );
  }, "setProductOption");
  const setSellingPlan = /* @__PURE__ */ __name((selling_plan_id) => {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2, _j2, _k2;
    state.selected_selling_plan = (_a2 = state.selling_plan_allocations.find(
      (allocation) => allocation.selling_plan.id === selling_plan_id
    )) == null ? void 0 : _a2.selling_plan;
    const selling_plan = (_c2 = state.selected_selling_plan) != null ? _c2 : (_b2 = selling_plan_allocations == null ? void 0 : selling_plan_allocations[0]) == null ? void 0 : _b2.selling_plan;
    state.selling_plan_discount_wording = ((_e2 = (_d2 = selling_plan == null ? void 0 : selling_plan.price_adjustments) == null ? void 0 : _d2[0]) == null ? void 0 : _e2.value_type) === "fixed_amount" ? `${utils.formatMoney((_g2 = (_f2 = selling_plan == null ? void 0 : selling_plan.price_adjustments) == null ? void 0 : _f2[0]) == null ? void 0 : _g2.value)}` : ((_i2 = (_h2 = selling_plan == null ? void 0 : selling_plan.price_adjustments) == null ? void 0 : _h2[0]) == null ? void 0 : _i2.value_type) === "percentage" ? `${(_k2 = (_j2 = selling_plan == null ? void 0 : selling_plan.price_adjustments) == null ? void 0 : _j2[0]) == null ? void 0 : _k2.value}%` : "";
  }, "setSellingPlan");
  const getDynamicText = /* @__PURE__ */ __name((content) => {
    return utils.getBracketInputDynamicPluralizedText(content, state);
  }, "getDynamicText");
  const getDynamicValue = /* @__PURE__ */ __name((content) => {
    return utils.getBracketInputDynamicValue(content, state);
  }, "getDynamicValue");
  const getDynamicValueWithFallbacks = /* @__PURE__ */ __name((content) => {
    var _a2;
    return (_a2 = content.split(",")) == null ? void 0 : _a2.reduce((acc, item) => {
      acc || (acc = utils.getBracketInputDynamicValue(item.trim(), state));
      return acc;
    }, "");
  }, "getDynamicValueWithFallbacks");
  const getContentLabels = /* @__PURE__ */ __name((key) => {
    const labels = key.split(".").reduce((acc, selector) => {
      if (!selector || acc === void 0 || acc === null) return acc || "";
      if (acc && selector in acc) {
        return acc[selector];
      }
      return "";
    }, state);
    if (Array.isArray(labels)) {
      return labels.filter(Boolean);
    }
    return [labels].filter(Boolean);
  }, "getContentLabels");
  const getDiscountLabel = /* @__PURE__ */ __name((type) => {
    var _a2, _b2, _c2, _d2, _e2;
    const price = (_b2 = (_a2 = state.selected_variant) == null ? void 0 : _a2.price) != null ? _b2 : 0;
    const compare_at_price = (_d2 = (_c2 = state.selected_variant) == null ? void 0 : _c2.compare_at_price) != null ? _d2 : 0;
    if (compare_at_price <= price) {
      return "";
    }
    switch (type) {
      case "sale": {
        return "Sale";
      }
      case "percentage": {
        return `${Math.round((compare_at_price - price) * 100 / compare_at_price)}% off`;
      }
      case "value": {
        return `Save ${utils.formatMoney(
          compare_at_price - price,
          (_e2 = window == null ? void 0 : window.money_format) == null ? void 0 : _e2.replace(/\{(\s*)amount(\s*)}/gi, "{$1amount_no_decimals$2}")
        )}`;
      }
      default: {
        return "";
      }
    }
  }, "getDiscountLabel");
  const getVariantSwatches = /* @__PURE__ */ __name((primary_source, fallback_source, variant) => {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2, _j2;
    const cssVariables = [];
    switch (primary_source) {
      case "title": {
        cssVariables.push(`--primary-swatch: var(--swatch-${utils.handlelize(variant.title)})`);
        break;
      }
      case "image": {
        const [src, version] = (_c2 = (_b2 = (_a2 = variant == null ? void 0 : variant.featured_media) == null ? void 0 : _a2.preview_image) == null ? void 0 : _b2.src.split("?")) != null ? _c2 : [];
        if (!src) break;
        cssVariables.push(`--primary-swatch: url(${src}?width=60&height=60&${version}) center center/cover no-repeat`);
        break;
      }
      case "metafield": {
        const color_swatch = variant.metafields.smart.color_swatch;
        if (typeof color_swatch === "string") {
          cssVariables.push(`--primary-swatch: ${color_swatch}`);
          break;
        }
        if (color_swatch) {
          const [src, version] = (_e2 = (_d2 = color_swatch == null ? void 0 : color_swatch.preview_image) == null ? void 0 : _d2.src.split("?")) != null ? _e2 : [];
          if (!src) break;
          cssVariables.push(`--primary-swatch: url(${src}?width=60&height=60&${version}) center center/cover no-repeat`);
          cssVariables.push(`--primary-swatch: ${color_swatch}`);
        }
        break;
      }
    }
    switch (fallback_source) {
      case "title": {
        cssVariables.push(`--fallback-swatch: var(--swatch-${utils.handlelize(variant.title)})`);
        break;
      }
      case "image": {
        const [src, version] = (_h2 = (_g2 = (_f2 = variant == null ? void 0 : variant.featured_media) == null ? void 0 : _f2.preview_image) == null ? void 0 : _g2.src.split("?")) != null ? _h2 : [];
        if (!src) break;
        cssVariables.push(`--fallback-swatch: url(${src}?width=60&height=60&${version}) center center/cover no-repeat`);
        break;
      }
      case "metafield": {
        const color_swatch = variant.metafields.smart.color_swatch;
        if (typeof color_swatch === "string") {
          cssVariables.push(`--fallback-swatch: ${color_swatch}`);
          break;
        }
        if (color_swatch) {
          const [src, version] = (_j2 = (_i2 = color_swatch == null ? void 0 : color_swatch.preview_image) == null ? void 0 : _i2.src.split("?")) != null ? _j2 : [];
          if (!src) break;
          cssVariables.push(`--fallback-swatch: url(${src}?width=60&height=60&${version}) center center/cover no-repeat`);
          cssVariables.push(`--fallback-swatch: ${color_swatch}`);
        }
        break;
      }
    }
    return `${cssVariables == null ? void 0 : cssVariables.join(";")};background: var(--primary-swatch, var(--fallback-swatch, ${utils.handlelize(
      variant == null ? void 0 : variant.title
    )}))`;
  }, "getVariantSwatches");
  const getOptionIndex = /* @__PURE__ */ __name((blockId) => {
    var _a2, _b2, _c2, _d2, _e2;
    const optionBlocks = [];
    for (let i = 0; i < (((_b2 = (_a2 = state.product) == null ? void 0 : _a2.options) == null ? void 0 : _b2.length) || 0); i++) {
      const option = (_c2 = state.product) == null ? void 0 : _c2.options[i];
      const byNameBlock = option_blocks == null ? void 0 : option_blocks.find((block) => {
        var _a3, _b3;
        const alreadyUsed = optionBlocks.some((b) => b.id === block.block_id);
        if (alreadyUsed || block.option_type !== "by_name") return false;
        if (block.match_exact_word) {
          return (_a3 = block.match_option_titles) == null ? void 0 : _a3.split(",").includes(option);
        }
        return (_b3 = block.match_option_titles) == null ? void 0 : _b3.split(",").map((o) => o.toLowerCase().trim()).includes(option.toLowerCase().trim());
      });
      if (byNameBlock) {
        optionBlocks.push({ index: i, id: byNameBlock.block_id });
        continue;
      }
      const byIndexOptions = option_blocks == null ? void 0 : option_blocks.find(
        (block) => !optionBlocks.some((b) => b.id === block.block_id) && block.option_type === "by_index" && block.match_option_index === i
      );
      if (byIndexOptions) {
        optionBlocks.push({ index: i, id: byIndexOptions.block_id });
        continue;
      }
      const fallbackOptions = option_blocks == null ? void 0 : option_blocks.find(
        (block) => !optionBlocks.some((b) => b.id === block.block_id) && block.option_type === "fallback_options" && block.match_option_index === i
      );
      if (fallbackOptions) {
        optionBlocks.push({ index: i, id: fallbackOptions.block_id });
      }
    }
    return (_e2 = (_d2 = optionBlocks == null ? void 0 : optionBlocks.find((block) => block.id === blockId)) == null ? void 0 : _d2.index) != null ? _e2 : -1;
  }, "getOptionIndex");
  const getOptionSwatches = /* @__PURE__ */ __name((primary_source, fallback_source, value, index) => {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2, _j2, _k2, _l2, _m2, _n2, _o2, _p2;
    const variant = (_b2 = (_a2 = state == null ? void 0 : state.product) == null ? void 0 : _a2.variants) == null ? void 0 : _b2.find((variant2) => variant2.options[index] === value);
    const cssVariables = [];
    switch (primary_source) {
      case "title": {
        cssVariables.push(`--primary-swatch: var(--swatch-${utils.handlelize(value)})`);
        break;
      }
      case "image": {
        const [src, version] = (_f2 = (_e2 = (_d2 = (_c2 = variant == null ? void 0 : variant.featured_media) == null ? void 0 : _c2.preview_image) == null ? void 0 : _d2.src) == null ? void 0 : _e2.split("?")) != null ? _f2 : [];
        if (!src) break;
        cssVariables.push(`--primary-swatch: url(${src}?width=60&height=60&${version}) center center/cover no-repeat`);
        break;
      }
      case "metafield": {
        const color_swatch = variant.metafields.smart.color_swatch;
        if (typeof color_swatch === "string") {
          cssVariables.push(`--primary-swatch: ${color_swatch}`);
          break;
        }
        if (color_swatch) {
          const [src, version] = (_i2 = (_h2 = (_g2 = color_swatch == null ? void 0 : color_swatch.preview_image) == null ? void 0 : _g2.src) == null ? void 0 : _h2.split("?")) != null ? _i2 : [];
          if (!src) break;
          cssVariables.push(`--primary-swatch: url(${src}?width=60&height=60&${version}) center center/cover no-repeat`);
          cssVariables.push(`--primary-swatch: ${color_swatch}`);
        }
        break;
      }
    }
    switch (fallback_source) {
      case "title": {
        cssVariables.push(`--fallback-swatch: var(--swatch-${utils.handlelize(value)})`);
        break;
      }
      case "image": {
        const [src, version] = (_m2 = (_l2 = (_k2 = (_j2 = variant == null ? void 0 : variant.featured_media) == null ? void 0 : _j2.preview_image) == null ? void 0 : _k2.src) == null ? void 0 : _l2.split("?")) != null ? _m2 : [];
        if (!src) break;
        cssVariables.push(`--fallback-swatch: url(${src}?width=60&height=60&${version}) center center/cover no-repeat`);
        break;
      }
      case "metafield": {
        const color_swatch = variant.metafields.smart.color_swatch;
        if (typeof color_swatch === "string") {
          cssVariables.push(`--fallback-swatch: ${color_swatch}`);
          break;
        }
        if (color_swatch) {
          const [src, version] = (_p2 = (_o2 = (_n2 = color_swatch == null ? void 0 : color_swatch.preview_image) == null ? void 0 : _n2.src) == null ? void 0 : _o2.split("?")) != null ? _p2 : [];
          if (!src) break;
          cssVariables.push(`--fallback-swatch: url(${src}?width=60&height=60&${version}) center center/cover no-repeat`);
          cssVariables.push(`--fallback-swatch: ${color_swatch}`);
        }
        break;
      }
    }
    return `${cssVariables == null ? void 0 : cssVariables.join(";")};background: var(--primary-swatch, var(--fallback-swatch, ${utils.handlelize(value)}))`;
  }, "getOptionSwatches");
  const truncateChildren = /* @__PURE__ */ __name((element, container) => {
    var _a2, _b2;
    const children = [...container.children];
    if (((_a2 = children.at(-2)) == null ? void 0 : _a2.offsetLeft) + ((_b2 = children.at(-2)) == null ? void 0 : _b2.clientWidth) < container.clientWidth) {
      return children.length - 2;
    }
    return children.findIndex(
      (childElement) => childElement.offsetLeft + childElement.clientWidth + element.clientWidth + +getComputedStyle(container).gap.replace("px", "") + 15 > container.clientWidth
    ) - 1;
  }, "truncateChildren");
  const hasAvailableVariant = /* @__PURE__ */ __name((index, value) => {
    var _a2, _b2;
    return (_b2 = (_a2 = state == null ? void 0 : state.product) == null ? void 0 : _a2.variants) == null ? void 0 : _b2.some((variant) => {
      switch (index) {
        case 0: {
          return variant.options[index] === value && variant.available;
        }
        case 1: {
          return variant.options[0] === (state == null ? void 0 : state.selected_options[0]) && variant.options[index] === value && variant.available;
        }
        case 2: {
          return variant.options[0] === (state == null ? void 0 : state.selected_options[0]) && variant.options[1] === (state == null ? void 0 : state.selected_options[1]) && variant.options[index] === value && variant.available;
        }
      }
      return false;
    });
  }, "hasAvailableVariant");
  const updateProductState = /* @__PURE__ */ __name((product2, selectedVariantId, selectedSellingPlanId) => {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2, _j2, _k2, _l2, _m2, _n2, _o2, _p2, _q2, _r2, _s2;
    if ((settings == null ? void 0 : settings.default_variant_metafield) && product2) {
      const [namespace, key] = settings.default_variant_metafield.trim().split(".");
      const variant = (_b2 = (_a2 = product2 == null ? void 0 : product2.metafields) == null ? void 0 : _a2[namespace]) == null ? void 0 : _b2[key];
      product2.selected_variant_id = (_c2 = variant == null ? void 0 : variant.id) != null ? _c2 : product2 == null ? void 0 : product2.selected_variant_id;
    }
    const selected_variant2 = _product.getSelectedVariant(product2, selectedVariantId);
    const selling_plan_allocations2 = selected_variant2 == null ? void 0 : selected_variant2.selling_plan_allocations;
    const selected_selling_plan2 = selectedSellingPlanId ? (_d2 = selling_plan_allocations2 == null ? void 0 : selling_plan_allocations2.find((plan) => plan.selling_plan.id === selectedSellingPlanId)) == null ? void 0 : _d2.selling_plan : default_select_selling_plan ? (_e2 = selling_plan_allocations2 == null ? void 0 : selling_plan_allocations2[0]) == null ? void 0 : _e2.selling_plan : null;
    const selling_plan_discount_wording2 = +((_g2 = (_f2 = selected_selling_plan2 == null ? void 0 : selected_selling_plan2.price_adjustments) == null ? void 0 : _f2[0]) == null ? void 0 : _g2.value) ? ((_i2 = (_h2 = selected_selling_plan2 == null ? void 0 : selected_selling_plan2.price_adjustments) == null ? void 0 : _h2[0]) == null ? void 0 : _i2.value_type) === "fixed_amount" ? `${utils.formatMoney((_k2 = (_j2 = selected_selling_plan2 == null ? void 0 : selected_selling_plan2.price_adjustments) == null ? void 0 : _j2[0]) == null ? void 0 : _k2.value)} off` : ((_m2 = (_l2 = selected_selling_plan2 == null ? void 0 : selected_selling_plan2.price_adjustments) == null ? void 0 : _l2[0]) == null ? void 0 : _m2.value_type) === "percentage" ? `Save ${(_o2 = (_n2 = selected_selling_plan2 == null ? void 0 : selected_selling_plan2.price_adjustments) == null ? void 0 : _n2[0]) == null ? void 0 : _o2.value}%` : "" : "";
    state.product = product2;
    state.product_handle = (_q2 = (_p2 = product2 == null ? void 0 : product2.handle) != null ? _p2 : state.product_handle) != null ? _q2 : productHandle;
    state.selected_media_id = (_s2 = (_r2 = product2 == null ? void 0 : product2.media) == null ? void 0 : _r2[0]) == null ? void 0 : _s2.id;
    state.properties = {};
    state.selected_variant = selected_variant2;
    state.selling_plan_allocations = selling_plan_allocations2;
    state.selected_selling_plan = selected_selling_plan2;
    state.selling_plan_discount_wording = selling_plan_discount_wording2;
    state.isAdding = false;
    state.selected_options = selected_variant2 == null ? void 0 : selected_variant2.options;
    state.quantity = 1;
    state.sibling_handle = "";
    state.gallery_media = product2 == null ? void 0 : product2.media;
    state.hydrated = true;
  }, "updateProductState");
  const showConditionally = /* @__PURE__ */ __name((condition, bundle) => {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2;
    switch (condition) {
      case "always": {
        return true;
      }
      case "with_subscriptions": {
        return !!((_b2 = (_a2 = state.selected_variant) == null ? void 0 : _a2.selling_plan_allocations) == null ? void 0 : _b2.length);
      }
      case "no_subscriptions": {
        return !((_d2 = (_c2 = state.selected_variant) == null ? void 0 : _c2.selling_plan_allocations) == null ? void 0 : _d2.length);
      }
      case "no_bundle": {
        return !(bundle == null ? void 0 : bundle.items_added);
      }
      case "bundle": {
        return !!(bundle == null ? void 0 : bundle.items_added);
      }
      case "with_variants": {
        return ((_f2 = (_e2 = state == null ? void 0 : state.product) == null ? void 0 : _e2.variants) == null ? void 0 : _f2.length) > 1;
      }
      case "no_variants": {
        return ((_h2 = (_g2 = state == null ? void 0 : state.product) == null ? void 0 : _g2.variants) == null ? void 0 : _h2.length) <= 1;
      }
    }
  }, "showConditionally");
  const hideIfEmpty = /* @__PURE__ */ __name((element, hide_if_empty, isEmpty = false) => {
    var _a2, _b2;
    switch (hide_if_empty) {
      case "none":
        break;
      case "section":
        (_a2 = element.closest(`.shopify-section`)) == null ? void 0 : _a2.classList.toggle("!hidden", isEmpty);
        break;
      case "container":
        (_b2 = element.closest(`[data-style-id]:not([data-style-id="${element.getAttribute("data-style-id")}"])`)) == null ? void 0 : _b2.classList.toggle("!hidden", isEmpty);
        break;
      case "block":
        break;
    }
  }, "hideIfEmpty");
  const getDataAttribute = /* @__PURE__ */ __name((el) => {
    return el.hasAttribute("data-sold-out-action") && state.soldOut ? "sold-out-" : el.closest("[data-bundle-section]") && el.hasAttribute("data-bundle-action") ? "bundle-" : el.hasAttribute("data-pdp-action") && addon_target ? "pdp-" : el.hasAttribute("data-preorder-action") && state.preorder ? "preorder-" : el.hasAttribute("data-subscription-action") && state.hasSubscription ? "subscription-" : el.hasAttribute("data-variant-action") && state.hasVariants ? "variant-" : "";
  }, "getDataAttribute");
  const getCTAButtonProps = /* @__PURE__ */ __name((el, preview) => {
    var _a2, _b2, _c2, _d2;
    let attribute = getDataAttribute(el);
    if (preview) {
      switch (preview) {
        case "default":
          attribute = "";
          break;
        case "variant":
          attribute = "variant-";
          break;
        case "subscription":
          attribute = "";
          break;
        case "bundle":
          attribute = "bundle-";
          break;
        case "bundle_added":
          attribute = "bundle-";
          break;
        case "in_pdp":
          attribute = "pdp-";
          break;
        case "in_pdp_added":
          attribute = "pdp-";
          break;
        case "out_of_stock":
          attribute = "sold-out-";
          break;
      }
    }
    return {
      content: utils.richtextWithPrices(
        el.getAttribute(`data-${attribute}content`),
        (_a2 = state == null ? void 0 : state.selected_variant) == null ? void 0 : _a2.price,
        (_b2 = state.selected_variant) == null ? void 0 : _b2.compare_at_price
      ),
      added_content: utils.richtextWithPrices(
        el.getAttribute(`data-${attribute}added-content`),
        (_c2 = state == null ? void 0 : state.selected_variant) == null ? void 0 : _c2.price,
        (_d2 = state.selected_variant) == null ? void 0 : _d2.compare_at_price
      ),
      action: el.getAttribute(`data-${attribute}action`),
      classes: el.getAttribute(`data-${attribute}class`),
      product_modal_handle: el.getAttribute(`data-${attribute}product-modal-handle`)
    };
  }, "getCTAButtonProps");
  Alpine.effect(() => {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2, _j2;
    const product2 = state.product;
    const selected_variant2 = state.selected_variant;
    state.hasVariants = ((_a2 = product2 == null ? void 0 : product2.variants) == null ? void 0 : _a2.length) > 1 || ((_c2 = (_b2 = product2 == null ? void 0 : product2.variants) == null ? void 0 : _b2[0]) == null ? void 0 : _c2.title) !== "Default Title";
    state.hasSubscription = !!((_d2 = selected_variant2 == null ? void 0 : selected_variant2.options) == null ? void 0 : _d2.length);
    state.available_quantity = (selected_variant2 == null ? void 0 : selected_variant2.inventory_management) === "shopify" && (selected_variant2 == null ? void 0 : selected_variant2.inventory_policy) === "deny" ? (selected_variant2 == null ? void 0 : selected_variant2.inventory_quantity) - ((_f2 = (_e2 = cart == null ? void 0 : cart.state) == null ? void 0 : _e2.items) == null ? void 0 : _f2.reduce((acc, line) => line.variant_id === selected_variant2.id ? acc + line.quantity : acc, 0)) : (selected_variant2 == null ? void 0 : selected_variant2.preorder) && (selected_variant2 == null ? void 0 : selected_variant2.preorder_quantity) ? (selected_variant2 == null ? void 0 : selected_variant2.inventory_quantity) + (selected_variant2 == null ? void 0 : selected_variant2.preorder_quantity) - ((_h2 = (_g2 = cart == null ? void 0 : cart.state) == null ? void 0 : _g2.items) == null ? void 0 : _h2.reduce((acc, line) => line.variant_id === selected_variant2.id ? acc + line.quantity : acc, 0)) : 99999;
    state.soldOut = state.available_quantity <= 0;
    state.preorder = (selected_variant2 == null ? void 0 : selected_variant2.preorder) && (selected_variant2 == null ? void 0 : selected_variant2.inventory_quantity) - ((_j2 = (_i2 = cart == null ? void 0 : cart.state) == null ? void 0 : _i2.items) == null ? void 0 : _j2.reduce((acc, line) => line.variant_id === selected_variant2.id ? acc + line.quantity : acc, 0)) < preorder_threshold;
  });
  return {
    p_card: state,
    $el,
    $refs,
    handleAddToCart,
    handleBackInStockNotification,
    setSelectedVariant,
    setProductOption,
    setSellingPlan,
    getDynamicText,
    getDynamicValue,
    getDynamicValueWithFallbacks,
    getContentLabels,
    getDiscountLabel,
    getVariantSwatches,
    getOptionIndex,
    getOptionSwatches,
    truncateChildren,
    hasAvailableVariant,
    updateProductState,
    showConditionally,
    hideIfEmpty,
    getCTAButtonProps,
    handleImageSelection,
    scrollToMediaById
  };
}, "initProductCard");
const fallbackHydrationQueue = /* @__PURE__ */ new Set();
const hydrateProductCardContents = /* @__PURE__ */ __name(($el) => {
  var _a, _b, _c;
  const card_handle = $el.getAttribute(`data-card-handle`);
  const product_handle = $el.getAttribute(`data-product-handle`);
  const product_id = $el.getAttribute(`data-product-id`);
  const classes = utils.JSONParse((_a = $el.getAttribute(`data-card-classes`)) != null ? _a : "[]");
  const addon_target_product = $el.getAttribute("data-addon-product-target");
  const addon_auto_add = $el.hasAttribute("data-addon-auto-add");
  const addon_bundle_in_cart = $el.hasAttribute("data-addon-cart-bundle");
  const node = (_b = document.querySelector(`[data-product-card='${card_handle}']`)) == null ? void 0 : _b.cloneNode(true);
  if (!node) {
    fallbackHydrationQueue.add($el);
    return;
  }
  node.removeAttribute("data-product-card");
  node.setAttribute("data-product-handle", product_handle != null ? product_handle : "");
  node.setAttribute("data-product-id", product_id != null ? product_id : "");
  if (addon_target_product) {
    node.setAttribute("data-addon-product-target", addon_target_product);
    if (addon_auto_add) node.setAttribute("data-addon-auto-add", "");
    if (addon_bundle_in_cart) node.setAttribute("data-addon-cart-bundle", "");
  }
  node.querySelectorAll("[data-loop-item], [data-x-if], style").forEach((el) => {
    el.remove();
  });
  node.classList.add(...classes);
  (_c = $el.parentNode) == null ? void 0 : _c.replaceChild(node, $el);
}, "hydrateProductCardContents");
document.addEventListener("modalsLoaded", () => {
  fallbackHydrationQueue.forEach((el) => {
    hydrateProductCardContents(el);
  });
  fallbackHydrationQueue.clear();
});
const observer = new IntersectionObserver(
  (entries) => {
    for (const entry of entries) {
      if (entry.isIntersecting && entry.target instanceof HTMLElement) {
        hydrateProductCardContents(entry.target);
        observer.unobserve(entry.target);
      }
    }
  },
  { rootMargin: "300px 300px 300px 300px" }
);
const hydrateProductCard = /* @__PURE__ */ __name(($el) => {
  if ($el.hasAttribute("data-intersected")) {
    hydrateProductCardContents($el);
    return;
  }
  observer.observe($el);
}, "hydrateProductCard");
window._sections["initProductCard"] = initProductCard;
window._sections["hydrateProductCard"] = hydrateProductCard;
